import { apiEndpoints } from 'settings/_apiSettings'
import axios from 'settings/axios'

interface Specialty {
  id: string
  title: string
  professional_board: string
}

interface ListSpecialtiesResponse {
  specialties: Specialty[]
}

export const listSpecialties = async (query?: string): Promise<ListSpecialtiesResponse> => {
  try {
    const url = query ? `${apiEndpoints.SPECIALTIES}?query=${query}` : apiEndpoints.SPECIALTIES
    const specialties = (await axios.get(url)) as Specialty[]

    return {
      specialties
    }
  } catch (error) {
    throw error?.response?.status || error
  }
}
